import { fetchApi } from '@/api/client';
import type { SiteAccess } from '@/types/access';

export function getSiteAccess(siteId: string): Promise<SiteAccess> {
  return fetchApi<SiteAccess>(`/api/v1/access/sites/${encodeURIComponent(siteId)}`);
}
